module.exports = __webpack_public_path__ + "geomanist-regular-webfont.15172c4485d205a9b749.eot";


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/assets/fonts/geomanist/geomanist-regular-webfont.eot
// module id = ../../../../../src/assets/fonts/geomanist/geomanist-regular-webfont.eot
// module chunks = main